/** 장면 계산 도우미(시안 site.js 와 같은 곡선) */
export const clamp = (value: number, min: number, max: number) =>
  Math.min(max, Math.max(min, value));
export const lerp = (from: number, to: number, t: number) =>
  from + (to - from) * t;
/** 3차 가속·감속 */
export const easeInOut = (t: number) =>
  t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
/** 3차 감속 */
export const easeOut = (t: number) => 1 - Math.pow(1 - t, 3);
